import { FirebaseData } from "../General/FirebaseData";

type LocalConnectionType = "property" | "unit"
type ExternalConnectionType = "department" | "location"

export class CompanyIntegrationConnectionData extends FirebaseData {

  localType?: LocalConnectionType
  localIDs: (string | number)[] = []

  externalType?: ExternalConnectionType
  externalIDs: (string | number)[] = []

  setup(data: any) {
    this.localType = typeof data.localType === "string" ? data.localType : undefined;
    this.localIDs = Array.isArray(data.localIDs) ? data.localIDs : [];

    this.externalType = typeof data.externalType === "string" ? data.externalType : undefined;
    this.externalIDs = Array.isArray(data.externalIDs) ? data.externalIDs : [];

    super.setup(data);
  }
}